import {Locale} from '@dms/api/base';
import {LocalizedName} from '@dms/api/core';

import {CodeFormValue} from '../components/CodeFormSchema';

export type CodelistMutationCall =
  | {kind: 'rename'; name: string}
  | {kind: 'set'; locale: Locale; name: string}
  | {kind: 'remove'; locale: Locale};

interface BuildCodelistMutationCallsArgs {
  initialName: string;
  initialLocalizedNames: LocalizedName[];
  values: CodeFormValue;
}

export function buildCodelistMutationCalls(
  args: BuildCodelistMutationCallsArgs
): CodelistMutationCall[] {
  const calls: CodelistMutationCall[] = [];

  const trimmedName = args.values.name.trim();
  if (trimmedName !== args.initialName) {
    calls.push({kind: 'rename', name: trimmedName});
  }

  const initialByLocale = new Map(
    args.initialLocalizedNames.map((entry) => [entry.locale, entry.name])
  );

  for (const submitted of args.values.localizedNames ?? []) {
    const {locale} = submitted;
    const trimmed = submitted.name.trim();
    const initial = initialByLocale.get(locale) ?? '';

    if (trimmed === initial) {
      continue;
    }

    if (trimmed.length === 0) {
      calls.push({kind: 'remove', locale});
    } else {
      calls.push({kind: 'set', locale, name: trimmed});
    }
  }

  return calls;
}
